import globalStore from '@/stores';
import store from '../store';
import { getContractSummary } from '../api';
import { CONTRACT_STATUS } from '..';

export const initContractSummary = async () => {
  const res: any = await getContractSummary();
  store.setSummaryInfoMap(res?.data || {});
  const isNotice = res?.data?.[CONTRACT_STATUS.unsigned] > 0;
  globalStore.setNavBreathingLight('contractManage', isNotice);
};
